import Trackable from '@/components/common/trackable/trackable.component';
import { appleStore, googlePlay,logo_white } from '@/images';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

export default function DescriptionSection(): React.ReactNode {
  return (
    <div className='w-full space-y-8 sm:space-y-8 lg:w-1/2'>
      <Image
        src={logo_white.src}
        className='h-[40px] w-auto'
        height={44}
        width={170}
        alt='greet logo'
        aria-label='greet logo'
        priority
      />
      <p className=' text-white text-sm font-medium'>
        Greet is a subsidiary of Fydo <strong>{`(Lfyd Services Pvt Ltd)`}</strong>, your all-in-one
        event companion. From seamless ticket booking to personalized event
        recommendations, explore local happenings, unlock exclusive deals, and
        connect with the heartbeat of your city at the same time. A one stop
        platform designed to streamline the process of organizing events.
      </p>
      <div className='flex flex-row gap-4 relative z-10'>
        <Trackable eventName='Click' eventScope='Play Store Btn (Footer)'>
        <Link
          target='_blank'
          href='https://play.google.com/store/apps/details?id=com.fydo.eventorganiser&hl=en_IN&pli=1'
        >
          <Image src={googlePlay} className='w-44' alt='google play' />
        </Link>
        </Trackable>
        <Trackable eventName='Click' eventScope='App Store Btn (Footer)'>
        <Link
          target='_blank'
          href='https://apps.apple.com/in/app/greet-your-ticketing-partner/id6478972090'
        >
          <Image src={appleStore} className='w-44' alt='app store' />
        </Link>
        </Trackable>

      </div>
    </div>
  );
}
